export const formInitialValues = (data) => ({
  kodeKelompok: data?.kode_kelompok_anggaran ?? "",
  keterangan: data?.keterangan ?? "",
  idKelompok: data?.id_kelompok_anggaran ?? "",
  namaKelompok: data?.nama_kelompok_anggaran ?? "",
  idJenis: data?.id_jenis_anggaran ?? null,
  namaJenis: data?.nama_jenis_anggaran ?? "",
});
